// App.tsx
import React, { useRef } from 'react';
import Nav from './components/Nav';
import Welcome from './components/Welcome';
import About from './components/About';
import Contact from './components/Contact';
import { BrowserRouter as Router } from 'react-router-dom';
import Carousel, { CarouselHandle } from './components/Carousel';
import './App.css';

function App() {
  const carouselRef = useRef<CarouselHandle>(null); // Shared ref for Carousel
  const carouselContainerRef = useRef<HTMLDivElement>(null); // Ref for the Carousel container
  const contactRef = useRef<HTMLDivElement>(null); // Ref for the Contact section

  return (
    <Router>
      <main>
        <Nav 
          scrollToSlide={(index) => carouselRef.current?.scrollToSlide(index)}
          scrollToCarousel={() => carouselContainerRef.current?.scrollIntoView({ behavior: 'smooth' })}
          scrollToContact={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })}
        />
        <Welcome />
        <div ref={carouselContainerRef}>
          <Carousel ref={carouselRef} />
        </div>
        <About />
        <div ref={contactRef}>
          <Contact/>
        </div>
      </main>
    </Router>
  );
}

export default App;
